import type { FC } from 'react';
import { Box } from '@mui/material';

interface IOperatorLogoProps {
	/** 48px operator logo shown in the footer. Empty renders the placeholder. */
	operatorIconUrl?: string;
}

/** Circular 48px operator logo. */
export const OperatorLogo: FC<IOperatorLogoProps> = ({ operatorIconUrl }) => (
	<Box
		sx={{
			width: 48,
			height: 48,
			borderRadius: '50%',
			overflow: 'hidden',
			flexShrink: 0,
			bgcolor: 'solutions.100',
		}}
	>
		{operatorIconUrl && (
			<Box
				component="img"
				src={operatorIconUrl}
				alt=""
				sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
			/>
		)}
	</Box>
);
